export const initialSuggestionFormValues = {
  suggestion: '',
}
